export default __webpack_public_path__ + "static/media/01.9bb37109.jpg";